<template>
  <div class="solutions">
    <div class="container">
      <div class="heading">
        <h2>Solutions</h2>
        <p>
          All the features you would expect from a Video Conferencing app plus
          cutting-edge solutions
        </p>
      </div>
      <div class="row">
        <div
          class="col-sm-6 col-md-3 solution"
          v-for="solution in solutions"
          :key="solution.title"
        >
          <img :src="solution.img" alt="" />
          <h3>{{ solution.title }}</h3>
          <p>{{ solution.description }}</p>
          <a v-if="solution.link" :href="solution.link">
            Learn More
            <svg
              width="16"
              height="17"
              viewBox="0 0 16 17"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M5.52827 4.02861C5.78862 3.76826 6.21073 3.76826 6.47108 4.02861L10.4711 8.02861C10.7314 8.28896 10.7314 8.71107 10.4711 8.97141L6.47108 12.9714C6.21073 13.2318 5.78862 13.2318 5.52827 12.9714C5.26792 12.7111 5.26792 12.289 5.52827 12.0286L9.05687 8.50001L5.52827 4.97141C5.26792 4.71107 5.26792 4.28896 5.52827 4.02861Z"
                fill="#557EFB"
              />
            </svg>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Solutions",
  data() {
    return {
      solutions: [
        {
          title: "Rsources",
          description:
            "Engage with your readers and build loyal followers by sharing resources that you know they will love",
          img: require("../../../assets/img/sessions/Scheduler.svg")
        },
        {
          title: "Insights",
          description:
            "Get up to the minute data about your corner views, QR scans and viewers",
          img: require("../../../assets/img/sessions/analytics.svg")
        },
        {
          title: "Mobile Apps",
          description:
            "Extend your reach by being featured on an array of our mobile apps designed to reach new audiences.",
          img: require("../../../assets/img/sessions/mobile.svg")
        },
        {
          title: "Webinars",
          description:
            "AMA (Ask Me Anything) to Learning Session. Engage with an audience who will keep coming back for more.",
          link: "",
          img: require("../../../assets/img/sessions/screen-sharing.svg")
        }
      ]
    };
  }
};
</script>

<style lang="scss" scoped>
.solutions {
  padding: 70px 0;
  background-image: url("../../../assets/img/sessions/solutions-bg.svg") !important;
  background-repeat: no-repeat;
  background-size: cover;
  .heading {
    margin-bottom: 50px;
    h2 {
      font-style: normal;
      font-weight: bold;
      font-size: 32px;
      line-height: 44px;
      color: #474d52;
      margin-bottom: 5px;
      text-transform: uppercase;
      text-align: center;
    }
    p {
      font-style: normal;
      font-weight: normal;
      font-size: 16px;
      line-height: 22px;
      color: #474d52;
      text-align: center;
    }
  }
  .solution {
    margin-bottom: 48px;
    img {
      height: 48px;
      width: 48px;
      border-radius: 50%;
      margin-bottom: 20px;
    }
    h3 {
      font-style: normal;
      font-weight: bold;
      font-size: 20px;
      line-height: 27px;
      color: #474d52;
      margin-bottom: 8px;
    }
    p {
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 19px;
      color: #474d52;
      min-height: 54px;
    }
    a {
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 19px;
      color: #557efb;
    }
  }
}
</style>
